import { create } from "zustand";

export const selectMissingTxns = (state) => state.missingTicketsTxns;
export const selectMissingTxnsLoading = (state) => state.missingTicketsTxnsLoading;

const useTicketsReportStore = create((set) => ({
  missingTicketsTxns: undefined,
  missingTicketsTxnsLoading: false,

  setMissingTxns: (id, data) =>
    set((state) => ({
      missingTicketsTxns: { ...state.missingTicketsTxns, [id]: data },
    })),
  setMissingTxnsLoading: (loading) => set({ missingTicketsTxnsLoading: loading }),
  reset: () => set({ missingTicketsTxns: undefined, missingTicketsTxnsLoading: false }),
}));

export default useTicketsReportStore;
